import moment from "moment";

class FormatSlotDateFilter {

    public static $inject: string[] = ["$translate"];

    constructor($translate: ng.translate.ITranslateService) {
        return slot => {
            if (slot && slot.datetime && slot.duration) {
                const from = moment(slot.datetime);
                const to = moment(slot.datetime).add(slot.duration, "minutes");
                return $translate.instant("date_de_h_a_h", {
                    DATE: from.format("ddd LL"),
                    TIME_FROM: from.format("LT"),
                    TIME_TO: to.format("LT")
                });
            }
            return "";
        };
    }
}

angular
    .module("thor.core.dates.slot.filter", [])
    .filter("formatSlotDate", <any>FormatSlotDateFilter);
